import { useEffect, useRef } from "react"
import { Control, useController } from "react-hook-form"
import { DefaultInput } from "../DefaultInput"

const FormTextArea = ({
  control,
  label,
  name,
  parentBackgroundColor,
  autoFocus = false,
  formatText,
  testID,
  readOnly = false,
  disabled = false,
  rows,
  resize = true,
  className,
  lightOutline,
  onClick = () => {},
  ...inputProps
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>
  label: string
  name: string
  parentBackgroundColor: string
  autoFocus?: boolean
  value?: string
  formatText?: (text: string) => string
  testID?: string
  defaultValue?: string
  readOnly?: boolean
  disabled?: boolean
  rows: number
  resize?: boolean
  className?: string
  lightOutline?: boolean
  onClick?: () => void
}) => {
  const {
    field: { onChange, value: textValue },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: inputProps.value || inputProps.defaultValue || "",
  })

  const inputRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [autoFocus])

  useEffect(() => {
    if (inputProps.value === "") {
      onChange("")
    }
  }, [inputProps.value, onChange])

  return (
    <DefaultInput
      value={textValue}
      onChange={onChange}
      label={label}
      name={name}
      type="textarea"
      rows={rows}
      resize={resize}
      formatText={formatText}
      onClick={onClick}
      innerRef={inputRef}
      lightOutline={lightOutline}
      parentBackgroundColor={parentBackgroundColor}
      errorMessage={error?.message}
      testId={testID}
      disabled={disabled}
      className={className}
      readOnly={readOnly}
    />
  )
}

export default FormTextArea
